/*
 *
 * SystemPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 03-Oct-2024
 */

import SystemPopUp from './SystemPopUpContainer'

export default SystemPopUp
